import { RippleButton } from '@3plearning/chakra-mathletics-theme'

import { ErrorPage, type ErrorPageProps } from '../../content'
import GeneralErrorImage from './assets/Genaral Error.svg'

export function GeneralErrorPage(props: Partial<ErrorPageProps>) {
  return (
    <ErrorPage
      headingText={'Uh-oh! Something doesn’t add up.'}
      messageText={'Please click home to go back'}
      imageSrc={GeneralErrorImage}
      buttons={[
        () => <RippleButton>Home</RippleButton>
      ]}
      {...props}
    />
  )
}
